const validWording = "Please enter valid "
const pleaseEnterWording = "Please enter "
const selectWording = "Please select "

//common
export const futureTimeErrorMsg = "Future time is not allowed"
export const futureDateErrorMsg = "Future date is not allowed"
export const DOB = validWording + "Date of Birth"
export const postalCode = validWording + "Postal Code"
export const address = validWording + "Address"
export const unitNo = validWording + "Unit Number"
export const familyLeft = validWording + "family has the Deceased left"

//supporting documents
export const deathNature = selectWording + "the nature of death"
export const deathOccur = selectWording + "the death occur"

//policy information
export const policyNumberLength =
  pleaseEnterWording + "8 character policy number"
export const policyNumberRequired = pleaseEnterWording + "policy number"
// export const policyNumber =
//   pleaseEnterWording + "8 character policy number starting with ‘’"
export const policyNumber = pleaseEnterWording + "8 character policy number"
export const representativeName = validWording + "Representative's Name"
export const representativeCode = validWording + "Representative's Code"
export const representativeBranch = validWording + "Representative's Branch"
export const representativeContactNo =
  validWording + "Representative's Contact Number"

//deceased details
export const deceasedName = validWording + "Name of Deceased"
export const NRIC = validWording + "NRIC / Passport Number"
export const maritalStatus = validWording + "Marital Status"

//employer details
export const employerName = validWording + "Name of Employer"
export const officeTelNo = validWording + "Office Telephone Number"
export const employmentDate = validWording + "Date of Employment"

//claimant details
export const claimantName = validWording + "Name of Claimant"
export const claimantNricNumber = validWording + "Claimant NRIC/Passport Number"
export const claimantMobile = validWording + "Contact Number"
export const claimantEmail = validWording + "Email Address"
export const relationshipWithDeceased =
  validWording + "Relationship with the Deceased"

//particulars of death
export const deathDate = validWording + "Date of Death"
export const deathTime = validWording + "Time of Death"
export const accidentLocation = validWording + "Place of Accident"
export const locationReason =
  validWording + "Reason of Deceased at the location"
export const accidentDesc = validWording + "Describe of Accident happened"
export const deathCause = validWording + "Cause of Death"
export const deathLocation = validWording + "Place and Country of Death"
export const firstComplaintDate = validWording + "Date"
export const firstConsultationDate = validWording + "Date"
export const doctorName = validWording + "Name of Doctor"
export const doctorAddress = validWording + "Address of Doctor"
export const regularDoctorName =
  validWording + "name of Deceased’s regular doctor"
export const regularDoctorAddress =
  validWording + "address of Deceased’s regular doctor"
export const regularDoctorContactNo =
  validWording + "contact number of Deceased’s regular doctor"

//payment details
export const bankName = validWording + "Name of Bank"
export const accountNumber = validWording + "Bank Account Number"
export const accountName = validWording + "Name of Account Holder"
